module.exports = __webpack_public_path__ + "img/chevron-bar-down.4a0071e0.svg";